"use client";

import Marquee from "@components/ui/icon-marquee";
import Image from "next/image";
const brands = [{
  lightImg: "/assets/images/cert-g-1.png"
}, {
  lightImg: "/assets/images/cert-g-2.png"
}, {
  lightImg: "/assets/images/cert-g-3.png"
}, {
  lightImg: "/assets/images/cert-g-4.png"
}, {
  lightImg: "/assets/images/cert-g-1.png"
}, {
  lightImg: "/assets/images/cert-g-2.png"
}, {
  lightImg: "/assets/images/cert-g-3.png"
}, {
  lightImg: "/assets/images/cert-g-4.png"
}];
const BrandCard = ({
  lightImg
}: {
  lightImg: string;
}) => {
  return <figure className="relative w-24 h-24 sm:w-32 sm:h-32 cursor-pointer overflow-hidden mx-1 sm:mx-2" data-sentry-component="BrandCard" data-sentry-source-file="certificate-icons.tsx">
      <Image className="object-contain w-full h-full block" alt="Brand Logo" src={lightImg} width={122} height={100} data-sentry-element="Image" data-sentry-source-file="certificate-icons.tsx" />
    </figure>;
};
const CertificateIcons = () => {
  return <div className="mt-20" data-sentry-component="CertificateIcons" data-sentry-source-file="certificate-icons.tsx">
      <div className="mt-20 relative rounded-2xl flex h-full w-full max-w-screen-lg sm:max-w-[40rem] md:max-w-[48rem] lg:max-w-[64rem] xl:max-w-[80rem] flex-col items-center justify-center overflow-hidden py-5 bg-transparent">
        <Marquee pauseOnHover className="[--duration:20s] flex items-center" data-sentry-element="Marquee" data-sentry-source-file="certificate-icons.tsx">
          {brands.map((brand, index) => <BrandCard key={index} {...brand} />)}
        </Marquee>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-white dark:from-transparent"></div>
        <div className="pointer-events-none absolute inset-y-0 right-0 w-1/3 bg-gradient-to-l from-white dark:from-transparent"></div>
      </div>
    </div>;
};
export default CertificateIcons;